/**
 * EDC REST API
 * EDC REST APIs - merged by OpenApiMerger
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { map, Observable, throwError} from 'rxjs';

import { AssetInput, ContractAgreement, QuerySpec } from '../model'
import { CONNECTOR_MANAGEMENT_API } from '../../app/variables';
import { TokenClaimsService } from '../../app/auth/token-claims.service';
import { MANAGEMENT_API_CONTEXT } from '../variables';
import { ManagementRouteService } from '../common/managementRoute.service';

@Injectable({
  providedIn: 'root'
})
export class ContractAgreementService {

    constructor(
        private readonly http: HttpClient,
        private readonly managementRoute: ManagementRouteService
      ) {}

    /**
     * Gets all contract agreements according to a particular query
     * @param querySpec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryAllAgreements(querySpec?: QuerySpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<ContractAgreement>>;
    public queryAllAgreements(querySpec?: QuerySpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<ContractAgreement>>>;
    public queryAllAgreements(querySpec?: QuerySpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<ContractAgreement>>>;
    public queryAllAgreements(querySpec?: QuerySpec): Observable<any> {
      
      const url = this.managementRoute.getManagementBaseUrl();
      return this.http.post<any[]>(`${url}/contractagreements/request`, this.toJsonLdQuerySpec(querySpec)).pipe(
        map(items => items.map(item => this.toContractAgreementInstance(item)))
      );
    }

    private toContractAgreementInstance(raw: any): any {
    const withAccessor = (obj: Record<string, any>) => ({
      ...obj,
      optionalValue: (_prefix: string, name: string) => obj?.[name] ?? null,
    });
    return {
      ...raw
    };
  }

  private toJsonLdQuerySpec(querySpec?: QuerySpec): Record<string, any> {
    return {
      '@context': [MANAGEMENT_API_CONTEXT],
      '@type': 'QuerySpec',
      ...querySpec,
    };
  }
}
